import { useState } from "react";
import {  useNavigate } from "react-router-dom";



import Button from "@/components/buttons/Button";
import ApplicationCategory from "./fragments/applications-category";
import LicenceImage from "@/assets/images/licence-image.svg";
// import InvestmentImage from "@/assets/images/investmet-image.svg";



export default function ApplicationsApply() {
    const [selectedCategory, setSelectedCategory] = useState<'Licence' | 'Investment'>('Licence');
    const navigate = useNavigate();
    const handleCategorySelect = (category: 'Licence' | 'Investment') => {
        setSelectedCategory(category);

    };
    
    return (
        <div className="mt-2 ">
            <div className="flex justify-between items-center px-4 ">
                <div>
                    <span>Submit New Applications</span>
                </div>
                <div className="flex justify-between items-center gap-3">
                    <Button
                        type="button"
                        intent="default"
                        size="md"
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </Button>
                        <Button
                            onClick={() => {
                                if(selectedCategory === 'Licence'){
                                    navigate('/applications/licence')
                                }if(selectedCategory === 'Investment'){
                                    navigate('/applications/investment')
                                }
                            }}
                            type="button" intent="primary" size="md">
                            Continue
                        </Button>
                </div>
            </div>
            <div className="border-b border-secondary-100 mt-2"></div>

            <div className="flex justify-center items-center h-full">

            <div className="sm:grid sm:grid-cols-2 sm:gap-8 sm:max-w-2xl space-y-5 sm:space-y-0 mt-4">
                <ApplicationCategory
                    icon={<img src={LicenceImage} alt="Clipboard" />}
                    title="License"
                    description="Apply for a tourism license to operate a business in Zanzibar."
                    isSelected={selectedCategory === 'Licence'}
                    onSelect={() => handleCategorySelect('Licence')}
                />
                {/* <ApplicationCategory
                    icon={<img src={InvestmentImage} alt="Chart"  />}
                    title="Residence Registration"
                    description="Submit your project details for investment in tourism industry."
                    isSelected={selectedCategory === 'Investment'}
                    onSelect={() => handleCategorySelect('Investment')}
                /> */}
            </div>

            </div>
        </div>
    )
}